// Etikett til dekkene/hjulene på lageret: dekkhotellnummer, kunde, sett og plassering.
// Bygges som HTML-tekst, så alle verdier escapes (funn #30, regel S4).
import { escapeHtml } from "./format";
import { settTekst, kundeNavn, stedTekst } from "../constants/dekkhotell";

export function skrivUtEtikett(post) {
  const w = window.open("", "_blank", "width=420,height=600");
  if (!w) return alert("Tillat popup-vinduer for å skrive ut etiketten.");
  const navn = kundeNavn(post.kunde);
  const tlf = post.kunde?.normalizedPhone ? `…${post.kunde.normalizedPhone.slice(-3)}` : "";
  // To like etiketter, én per dekk/hjul.
  const etikett = `
    <div class="etikett">
      <div class="nr">${escapeHtml(post.nr)}</div>
      <div class="navn">${escapeHtml(navn)} <span class="tlf">${escapeHtml(tlf)}</span></div>
      <div class="sett">${escapeHtml(settTekst(post.lagret))}</div>
      ${post.sykkel ? `<div>${escapeHtml(post.sykkel)}</div>` : ""}
      <div class="plass">Plass: ${escapeHtml(stedTekst(post) || "—")}</div>
    </div>`;
  w.document.write(`<!doctype html><html lang="no"><head><meta charset="utf-8">
    <title>Etikett ${escapeHtml(post.nr)}</title>
    <style>
      body { font-family: system-ui, sans-serif; margin: 0; }
      .etikett { width: 90mm; padding: 4mm; border: 1px dashed #999; margin: 4mm; page-break-inside: avoid; }
      .nr { font-size: 28pt; font-weight: 800; letter-spacing: 1px; }
      .navn { font-size: 13pt; font-weight: 600; margin-top: 2mm; }
      .tlf { font-weight: 400; color: #444; }
      .sett, .plass { margin-top: 1mm; font-size: 11pt; }
      @media print { .etikett { border: none; } }
    </style></head><body>${etikett}${etikett}
    <script>window.onload = () => { window.print(); }</script></body></html>`);
  w.document.close();
}
